import { SchoolTile } from "@app/components/SchoolTile";
import React from "react";
import ReactDOM from "react-dom/client";

/**
 * Mount school tiles for testing purposes.
 */

const test1 = document.querySelector(".school-tile-test-1");
if (test1) {
  const root = ReactDOM.createRoot(test1);
  root.render(<SchoolTile name="A Really Really Long School Name" image={window.testProductCardImg} href="/" />);
}
